<style>

.v-calendar-daily_head-weekday,
.v-calendar-weekly__head-weekday {
    text-transform: unset !important;
}
</style>
<template>
    <v-row no-gutters>
        <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 'auto'">
            <v-row>
                <v-col v-if="showTypePicker">
                    <v-btn-toggle v-model="type" mandatory class="white--text" small>
                        <v-btn v-if="type == 'week'" value="week" :color="color"><v-icon left
                                                                                         class="primarytext--text">mdi-view-week</v-icon>{{ $translate('Week') }}</v-btn>
                        <v-btn v-else value="week" outlined :color="color"><v-icon left
                                                                                   :color="color">mdi-view-week-outline</v-icon>{{ $translate('Week') }}</v-btn>

                        <v-btn v-if="type == 'month'" value="month" :color="color"><v-icon left
                                                                                           class="primarytext--text">mdi-calendar-month</v-icon>{{ $translate('Month') }}</v-btn>
                        <v-btn v-else value="month" outlined :color="color"><v-icon left
                                                                                    :color="color">mdi-calendar-month-outline</v-icon>{{ $translate('Month') }}</v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
            <v-row>
                <v-col v-if="showDatePicker && !$vuetify.breakpoint.mobile">
                    <!-- requires 290px -->
                    <v-date-picker v-if="type == 'month'" class="ma-8 z-no-user-select" v-model="selectedMonth"
                                   :locale="$store.state.language" :color="selectedColor || 'primary'" first-day-of-week="1"
                                   :header-color="color" show-week locale-first-day-of-year="4" type="month" key="month" />

                    <v-date-picker v-else class="ma-8 z-no-user-select" v-model="selectedDates"
                                   :locale="$store.state.language" :color="selectedColor || 'primary'" first-day-of-week="1"
                                   :show-current="true" :header-color="color" range show-week locale-first-day-of-year="4"
                                   :selected-items-text="datePickerText" show-adjacent-months type="date" key="week" />
                </v-col>
            </v-row>
        </v-col>
        <v-col class="fill-height">
            <v-row no-gutters @wheel="onScroll($event)" @mouseup="stopDrag" @mousedown="startDrag"
                   @mousemove="doDrag">
                <v-col>
                    <div class="d-flex">
                        <div><v-icon @click="prev">mdi-chevron-left</v-icon></div>
                        <div class="flex-grow-1 text-center title primary--text" v-text="calendarTitle" />
                        <div><v-icon @click="next">mdi-chevron-right</v-icon></div>
                    </div>
                    <v-calendar style="width: 100%; height: 600px; user-select: none" ref="calendar"
                                :locale="$store.state.language" locale-first-day-of-year="4" :weekdays="weekdaysSorted"
                                :short-weekdays="$vuetify.breakpoint.mobile" :type="type"
                                :first-interval="Date.newFull(startTime).hhmm()" :interval-count="intervalCount" show-week
                                :interval-minutes="intervalMinutes" :events="filteredEvents"
                                :event-color="(event) => useWorkoutTypeColor ? event.color : color" :color="color"
                                v-model="selectedDate" @click:event="eventClicked" @click:more="viewDay">
                        <template #event="{ event }">
                            <v-sheet :color="(useWorkoutTypeColor ? event.color : color) || 'primary'"
                                     class="fill-height white--text text-truncate"
                                     :style="{ 'border-left': useWorkoutTypeColor ? ('4px solid' + event.color + ' !important') : undefined }">
                                <div class="pl-1" style="background-color: rgba(0,0,0,.1)">{{ event.name }}</div>
                            </v-sheet>
                        </template>

                    </v-calendar>

                </v-col>
            </v-row>

            <workout-dialog v-model="showWorkoutDialog" :workout="showingWorkout" v-if="showWorkoutDialog" />
        </v-col>
    </v-row>
</template>

<script>
import Vue from 'vue';
import WorkoutDialog from '../components/WorkoutDialog.vue'

export default {
    name: 'zoezi-activity-calendar',

    zoezi: {
        title: 'Activity Calendar',
        icon: 'mdi-calendar-month'
    },

    components: {
        WorkoutDialog,
    },

    props: {
        color: {
            title: 'Base color',
            type: String,
            fulltype: 'color',
            default: 'primary'
        },
        selectedColor: {
            title: 'Color for selected period',
            type: String,
            fulltype: 'color',
            default: 'primary'
        },
        weekdays: {
            title: 'Weekdays',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                nosort: true,
                text: 'name',
                value: 'id',
                getItems() {
                    let t = window.$translate;
                    return new Promise((resolve) => resolve([{ id: 1, name: 'Monday' }, { id: 2, name: 'Tuesday' }, { id: 3, name: 'Wednesday' }, { id: 4, name: 'Thursday' }, { id: 5, name: 'Friday' }, { id: 6, name: 'Saturday' }, { id: 0, name: 'Sunday' }].map(x => ({ ...x, name: t(x.name) }))));
                }
            },
            default: () => ([1, 2, 3, 4, 5, 6, 0])
        },
        category: {
            title: 'Category',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                placeholder: 'Show all categories',
                getItems: () => window.$booking.getWorkoutCategories()
            },
            default: () => []
        },
        defaultWorkoutTypes: {
            title: 'Filter by activity types',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                getItems: () => window.$booking.getWorkoutTypes()
            },
            default: () => []
        },
        useWorkoutTypeColor: {
            title: 'Use workout type color',
            type: Boolean,
            default: true
        },
        showDatePicker: {
            title: 'Show date picker',
            type: Boolean,
            default: true
        },
        showTypePicker: {
            title: 'Show week/month selector',
            type: Boolean,
            default: true
        },
        month: {
            title: 'Monthly view',
            type: Boolean,
            default: false
        },
        useExtraTitle: {
            title: 'Use supplementary text as headline',
            type: Boolean,
            default: false
        },
        showingWorkoutId: {
            title: 'Show activity - ID',
            type: String,
        }
    },

    data: () => ({
        workouts: [],
        workoutTypes: [],
        selectedDate: Date.today().yyyymmdd(),
        intervalMinutes: 60,
        dragging: false,
        x: 'no',
        y: 'no',
        type: 'week',
        showWorkoutDialog: false,
        showingWorkout: null,
        filter: {
            staffs: [],
            workoutTypes: []
        },
        selectedMonth: Date.firstDayThisMonth().yyyymmdd(),
        unsubscribe: [],
    }),
    watch: {
        month: {
            immediate: true,
            handler(value) {
                this.type = value ? 'month' : 'week';
            }
        },
        selectedMonth(month) {
            let first = Date.newFull(month + '-01');
            let last = new Date(first.getFullYear(), first.getMonth() + 1, 0);
            this.selectedDates = [first, last];
        },
        type(value) {
            if (value == 'month') {
                this.selectedMonth = this.selectedDate && Date.newFull(this.selectedDate).firstDayThisMonth().yyyymmdd().substring(0, 7);
            }
        },
        selectedDates: {
            immediate: true,
            handler(dates) {
                this.fetchWorkouts(dates[0], dates[1]);
            }
        },
        '$vuetify.breakpoint.mobile': {
            immediate: true,
            handler(mobile) {
                if (mobile) {
                    this.selectedDate = new Date().yyyymmdd();
                }
            }
        },
        showWorkoutDialog: {
            immediate: false,
            handler(show) {
                let id = show ? this.showingWorkout?.id : null;
                if (id != this.showingWorkoutId) {
                    this.setProp('showingWorkoutId', id);
                }
            }
        },
    },
    computed: {
        sortedStaffs() { return this.staffs.concat().sort((a, b) => a.name.localeCompare(b.name)) },
        sortedWorkoutTypes() { return this.workoutTypes.concat().sort((a, b) => a.name.localeCompare(b.name)) },
        filteredWorkouts() {
            let workouts = this.workouts.filter(x => !this.category || this.category.length == 0 || this.category.find(c => x.workoutType.category_id == c)).filter(x => x.startTime.withinRange(this.selectedDates[0], this.selectedDates[1]));

            return workouts;
        },
        startTime() {
            const intervalMillis = this.intervalMinutes * 60000;

            const startTime = this.filteredEvents.reduce((minMillis, workout) => {
                const workoutStartMillis = Date.newFull(workout.start).getMillisecondsToday() - intervalMillis - 1;
                return Math.min(minMillis, workoutStartMillis);
            }, Infinity);

            return startTime > 0 ? new Date(startTime) : Date.newFull('01-01-01 00:00');
        },
        intervalCount() {
            const intervalMillis = this.intervalMinutes * 60000;

            const endTime = this.filteredEvents.reduce((maxMillis, workout) => {
                const workoutEndMillis = Date.newFull(workout.end).getMillisecondsToday();
                return Math.max(maxMillis, workoutEndMillis);
            }, 0);

            const diff = endTime - this.startTime.getMillisecondsToday() + intervalMillis;
            return Math.ceil(diff / intervalMillis);
        },
        events() {
            return this.filteredWorkouts.map(w => ({
                name: this.useExtraTitle && w.extra_title != null ? w.extra_title : w.workoutType.name,
                start: w.startTime.dateTime(),
                end: w.endTime.dateTime(),
                color: w.workoutType.color,
                workout: w,
                timed: true
            }));
        },
        staffs() {
            let staffs = [];
            this.filteredWorkouts.forEach(w => {
                w.staffs.forEach(staff => {
                    staff.name = staff.firstname + ' ' + staff.lastname;
                    if (!staffs.find(s => s.id == staff.id)) {
                        staffs.push({ id: staff.id, name: staff.name, imagekey: staff.imagekey });
                    }
                })
            });

            return staffs;
        },
        filteredEvents() {
            let f = this.filter;
            return this.events.filter(e => {
                if (this.filter.workoutTypes.length == 0) {
                    return true;
                }

                return this.filter.workoutTypes.indexOf(e.workout.workoutType.id) != -1;
            }).filter(e => {
                if (this.filter.staffs.length == 0) {
                    return true;
                }

                return f.staffs.find(staff_id => e.workout.staffs.find(ws => ws.id == staff_id));
            });
        },
        selectedDates: {
            get() {
                if (this.type == 'week') {
                    return Date.newFull(this.selectedDate).getDateIntervalForWeek().map(x => x.yyyymmdd());
                } else {
                    return [Date.newFull(this.selectedDate).firstDayThisMonth().yyyymmdd(), Date.newFull(this.selectedDate).lastDayThisMonth().yyyymmdd()];
                }
            },
            set(newDates) {
                let a = Date.newFull(newDates[0]);
                let b = newDates.length > 1 ? Date.newFull(newDates[1]) : a;
                let d = a < b ? a : b;
                if (this.type == 'week') {
                    this.selectedDate = d.monday().yyyymmdd();
                } else {
                    this.selectedDate = a.firstDayThisMonth().yyyymmdd();
                }
            }
        },
        isCurrentWeek() {
            return Date.newFull(this.selectedDate).withinRange(this.$store.state.now30s.monday(), this.$store.state.now30s.monday().addDays(6));
        },
        datePickerText() {
            return Date.dateToDateString(this.selectedDates[0], this.selectedDates[1], this.$translate);
        },
        calendarTitle() {
            let d = Date.newFull(this.selectedDate);
            if (this.type == 'week') {
                return `${d.getFullYear()}, ${this.datePickerText}, ${this.$translate('week')} ${d.getWeekNumber()}`;
            } else {
                return `${d.getFullYear()}, ${this.$translate(d.getMonthName())}`
            }
        },
        weekdaysSorted() {
            return this.weekdays.concat().sort((a, b) => {
                if (a == 0) {
                    return 1;
                } else if (b == 0) {
                    return -1;
                }

                return a - b;
            });
        }
    },
    methods: {
        fetchShowingWorkout(workoutId) {
            this.$api.get('/api/public/workout/get', {id: workoutId}).then(workout => {
                this.$booking.transformWorkout(workout)
                this.showingWorkout = workout;
                this.showWorkoutDialog = true;
            })
        },
        viewDay({ date }) {
            this.selectedDate = date
            this.type = 'week'
        },
        onScroll(event) {
            if (!event.ctrlKey) {
                return;
            }
            event.preventDefault();

            let e = this.getScrollContainerElement();
            if (!e) {
                return;
            }
            let mpx = this.$refs.calendar.minutesToPixels(1);
            let minutes_scrolled = e.scrollTop / mpx;
            let x = event.wheelDelta < 0 ? 1 : -1;

            let im = Number(this.intervalMinutes);
            this.intervalMinutes = Math.max(10, Math.min(60, im + 5 * x));

            // FIXME: Update scroll position to match current position

            Vue.nextTick(() => {
                mpx = this.$refs.calendar.minutesToPixels(1);
                let minutes_scrolled_after = e.scrollTop / mpx;
                let mindiff = minutes_scrolled_after - minutes_scrolled;
                e.scroll(0, e.scrollTop - (mindiff * mpx));
            });
        },
        getScrollContainerElement() {
            return this.$refs.calendar.$el.getElementsByClassName('v-calendar-daily__scroll-area')[0];
        },
        startDrag(event) {
            this.dragging = true;
            this.x = event.clientX;
            this.y = event.clientY;
        },
        stopDrag() {
            this.dragging = false;
            this.x = this.y = 'no';
        },
        doDrag(event) {
            if (this.dragging) {
                let dy = this.y - event.clientY;
                let e = this.getScrollContainerElement();
                if (e) {
                    e.scroll(0, e.scrollTop + dy)
                }
                this.x = event.clientX;
                this.y = event.clientY;
            }
        },
        getWorkoutTypes() {
            this.$booking.getWorkoutTypes().then(x => this.workoutTypes = x);
        },
        fetchWorkouts(fromDate, toDate) {
            this.$api.get('/api/public/workout/get/all', { fromDate, toDate }).then(data => {
                data.workouts.forEach(x => this.$booking.transformWorkout(x))
                this.workouts = data.workouts

                if (this.showingWorkoutId) {
                    this.showingWorkout = this.workouts.find(workout => workout.id == this.showingWorkoutId);
                    this.showWorkoutDialog = true;
                }

                // Fetch showing workout if workout is not in the selected date range
                if (!this.showingWorkout && this.showingWorkoutId) {
                    this.fetchShowingWorkout(this.showingWorkoutId);
                }
            });
        },
        eventClicked({ event }) {
            this.showWorkoutDialog = true;
            this.showingWorkout = event.workout;
        },
        prev() {
            let dates = this.selectedDates.map(Date.newFull);
            if (this.type == 'month') {
                this.selectedMonth = dates[0].lastMonth().yyyymmdd().substring(0, 7);
            } else {
                this.selectedDates = [dates[0].addDays(-7), dates[1].addDays(-7)];
            }
        },
        next() {
            let dates = this.selectedDates.map(Date.newFull);
            if (this.type == 'month') {
                this.selectedMonth = dates[0].nextMonth().yyyymmdd().substring(0, 7);
            } else {
                this.selectedDates = [dates[0].addDays(7), dates[1].addDays(7)];
            }
        }
    },
    created() {
        this.filter.workoutTypes = this.defaultWorkoutTypes.slice();

        this.getWorkoutTypes();

        this.unsubscribe.push(this.$booking.subscribeWorkoutChanges(this.workouts));
    },
    destroyed() {
        this.unsubscribe.forEach(u => {
            if (u) {
                u();
            }
        })
    }
}
</script>
